export default __webpack_public_path__ + "static/media/HKG.f6da2945.svg";